import React, { useEffect } from 'react';
import { DialogComponent } from '../../../../../Components';
import InquiryStatusSelect from './InquiryStatusSelect';

const UpdateInquiryStatusDialog = ({ open, onClose, onSave }) => {
  const [selectedStatus, setSelectedStatus] = React.useState(null);
  useEffect(() => {
    return () => {
      setSelectedStatus(null);
    };
  }, [open]);
  return (
    <DialogComponent
      isOpen={open}
      onCloseClicked={onClose}
      onCancelClicked={onClose}
      onSaveClicked={(e) => {
        e.preventDefault();
        onSave(selectedStatus);
      }}
      saveIsDisabled={!selectedStatus}
      titleText={'update_inquiry_status'}
      dialogContent={
        <div className='d-flex fj-center fa-center'>
          <InquiryStatusSelect
            className={'w-270px'}
            status={selectedStatus}
            onChange={setSelectedStatus}
          />
        </div>
      }
      maxWidth={'sm'}
    />
  );
};
export default UpdateInquiryStatusDialog;
